<script lang="ts" setup>
/**
 * UI-kit component
 * Category: Modals
 * Name: AppModal
 * FIGMA: https://www.figma.com/design/n8yjfgcFUgYPq4BLYjeYcJ/Design-System--Client?node-id=20152-14439&m=dev
 */
import { ModalLayout } from '@brighterly/lib-lumee-ui'

import type { AppModalProps } from './interfaces'

import { LoaderOverlay } from '@shared/ui/loaders'

import { useAppModal } from './use-app-modal.hook'

defineOptions({
  name: 'AppModal',
})

const props = withDefaults(defineProps<AppModalProps>(), {
  showButtonClose: true,
  showButtonBack: false,
  loading: false,
  closeOnScrim: false,
  actions: 'stack',
})

const emit = defineEmits<{
  close: []
  back: []
}>()

const {
  modalDataQa,
  modalStyle,
  isActionsRow,
  actionsClass,
  closeDataQaMap,
  handleClose,
  handleBack,
  handleScrimClick,
} = useAppModal({
  props,
  onClose: () => emit('close'),
  onBack: () => emit('back'),
})
</script>

<template>
  <div
    class="app-modal"
    :data-qa="modalDataQa"
    :style="modalStyle"
  >
    <ModalLayout
      ref="layout"
      position="bottom"
      :show-button-close="showButtonClose"
      :show-button-back="showButtonBack"
      :close-disabled="loading"
      :data-qa-map="closeDataQaMap"
      @close="handleClose"
      @back="handleBack"
      @click.self="handleScrimClick"
    >
      <template
        v-if="$slots.topSlot"
        #topSlot
      >
        <slot name="topSlot" />
      </template>
      <template #contentSlot>
        <slot name="contentSlot" />
        <LoaderOverlay v-if="loading" />
      </template>
      <template
        v-if="$slots.bottomSlot"
        #bottomSlot
      >
        <div
          v-if="isActionsRow"
          :class="['app-modal__actions', actionsClass]"
        >
          <slot name="bottomSlot" />
        </div>
        <slot
          v-else
          name="bottomSlot"
        />
      </template>
    </ModalLayout>
  </div>
</template>

<style lang="scss" scoped src="./_app-modal.scss" />
